<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="$t('Invoice.invoice_selectInvoiceNo')"
      width="450px"
      class="make-invoice-select-invoice-dialog"
      :close-on-click-modal="false"
      :show-close="false"
      custom-class="app-main-content"
    >
      <div class="grid-view" style="height: 300px;">
        <div class="main-content">
          <div class="section grid-wrapper">
            <cargo-ag-grid
              :show-side-bar="false"
              :grid-params.sync="gridParams"
              :grid-options="gridOptions"
              :column-defs="columnDefs"
              :row-data="rowData"
              style="width: 100%;height: 100%;"
            />
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button type="primary" no="1" @click="enterEvent">{{ $t('common.btn.ok') }}</el-button>
        <el-button no="2" @click="cancel">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import { queryInvoiceNo } from '@/api/clearing/invoiceNo'
import { getLoading } from '@/utils/utilBaseElement'
import { getGridSelected } from '@/utils/agGrid'
import ColumnUtils from '@/utils/ColumnUtils'

export default {
  name: 'InvoiceNoSelector',
  props: {
    visible: { type: Boolean, required: true }, // 是否隐藏
    invoiceType: { type: Number, required: true }, // 发票类型
    invoiceCount: { type: Number, required: true } // 发票数量
  },
  data() {
    return {
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true
      },
      gridParams: {},
      gridApi: {},
      columnDefs: [],
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: []
    }
  },
  computed: {
    innerVisible() {
      return this.visible
    }
  },
  created() {
    this.columnDefs = [
      {
        headerName: '', width: 50, checkboxSelection: true,
        sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
        headerCheckboxSelection: true
      },
      { headerName: this.$t('Invoice.invoice_invoiceNo'), field: 'invoiceNo', width: 210 },
      { headerName: this.$t('Invoice.invoice_invoiceType'), field: 'invoiceType', width: 165,
        cellRenderer: (params) => {
          return ColumnUtils.invoiceTypeFunc(params.value)
        } }
    ]
  },
  beforeMount() {
    // 根据发票类型和当前登陆人查询发票号
    if (this.invoiceType !== null && this.invoiceType !== undefined && this.invoiceType !== 'undefined') {
      this.loading = getLoading()
      queryInvoiceNo({ invoiceType: this.invoiceType, recipienter: this.$store.getters.userId }).then(res => {
        if (res.data && res.data.length > 0) {
          this.rowData = res.data
        }
      }).finally(() => {
        this.loading.close()
      })
    }
  },
  methods: {
    cancel() {
      this.$emit('update:visible', false)
    },
    // 确定事件
    enterEvent() {
      const chooseRow = getGridSelected(this.gridOptions)
      const invoiceCount = this.invoiceCount
      if (chooseRow.length === 0 || (invoiceCount === 1 && chooseRow.length === 0)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectInvoiceNo'))
        return
      } else if (invoiceCount === 1 && chooseRow.length !== 1) {
        this.$message.warning(this.$t('Clearing.OnlyNumberCanBeSelected'))
        return
      } else if (invoiceCount > 1 && chooseRow.length !== invoiceCount) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseBatchSelectInvoiceNo').format(invoiceCount))
        return
      }
      this.$emit('selectedInvoiceNoCallBackEvent', chooseRow)
    }
  }
}
</script>
